import React, {useState, useContext, useEffect} from "react";
import {GlobalContext} from "../context/GlobalState";
import {css} from "emotion";
import {boxStyles, colors, textSizes} from "../styles/theme";
import SwitchHeader from "../components/SwitchHeader";
import TitleBlock from "../components/TitleBlock";
import GenericButton from "../components/GenericButton";
import auth from "../services/api/auth";
import {withRouter, Link} from "react-router-dom";
import {useForm,} from "react-hook-form";
import ErrorMessage from "../components/ErrorMessage";

const ForgotPassword = ({history}) => {
  useEffect(() => {
    document.title = 'Forgot Password - Spotlight'
  });

  const {doLogin} = useContext(GlobalContext);
  const methods = useForm();
  const {register, handleSubmit, errors, setError} = methods;

  const [isLoading, setLoading] = useState(false);
  const [linkWasSent, setLinkWasSent] = useState(false);

  const handleResetClick = async ({email}) => {
    setLoading(true);
    const resetData = {
      emailAddress: email,
    };

    try {
      await auth.recoverPassword(resetData);

      setLinkWasSent(true);
    } catch (error) {
      if (error.response) {
        console.log('ERROR SENDING EMAIL');
      } else if (error.request) {
        setError('passwordReset', 'noConnection', 'You seem to have gotten disconnected. Make sure your internet is connected and try again.');
        console.log(error.request);
      } else {
        setError('passwordReset', 'unexpected', 'There was a problem logging into your account. Please reload the page and try again.');
        console.log('Error', error.message);
      }
      setLoading(false);
    }
  };

  return (
    <div className={container}>
      <SwitchHeader/>
      <div className="body">
        <div className="centerBlock">
          <div className="hero">
            <TitleBlock
              title="Forget your password?"
              subtitle="At least you don't use the same password for everything..."
            />
          </div>
          <form className="form">
            {errors.passwordReset && <ErrorMessage>{errors.passwordReset.message}</ErrorMessage>}
            <div className="formItem">
              <label>
                <p>EMAIL</p>
                <input
                  name="email"
                  type="email"
                  ref={register({
                    required: {
                      value: true,
                      message: 'Email is required'
                    },
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      message: "Invalid email address"
                    }
                  })}
                />
              </label>
              {errors.email && <ErrorMessage>{errors.email.message}</ErrorMessage>}
            </div>
            <div className="buttonSection">
                {linkWasSent ? (
                  <p>We've sent a password reset link to this email. If you don't see it immediately, give it a minute or two.</p>
                ) : (
                  <div className="button">
                    <GenericButton
                      text="Send Reset Link"
                      handleClick={handleSubmit(handleResetClick)}
                      disabled={isLoading}
                    />
                  </div>
                )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default withRouter(ForgotPassword);

const container = css`
  display: flex;
  flex-direction: column;

  .body {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .centerBlock {
    max-width: 650px;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
  }

  .hero {
    max-width: 650px;
    width: 100%;
    padding: 40px 0;
  }
  .form {
    width: 90%;
    max-width: 455px;

    .buttonSection {
      display: flex;
      flex: 1;
      justify-content: center;
      padding: 10px;
      margin-top: 24px;

      .button {
        width: 50%;
      }
      button:focus {
        outline: none;
      }
    }
  }
  .formItem {
    padding: 10px;

    label {
      font-size: ${textSizes.normal};
      color: ${colors.placeholderText};

      input {
        color: ${colors.inputTextColor};
        box-sizing: border-box;
        width: 100%;
        background-color: ${colors.inputBackground};
        padding: 10px;
        border: none;
        border-radius: ${boxStyles.borderRadius};
        color: ${colors.inputTextColor};
        font-size: ${textSizes.normal};
        outline: none;
      }
    }
  }

  .passwordInput {
    p {
      bottom: 10px;
      right: 10px;
    }
  }
  
  .forgot-password-link {
    display: inline-block;
    margin-left: 5px;
    color: ${colors.placeholderText};
    text-decoration: none;
    opacity: .7;
    transition-duration: .2s;
    padding: 5px 0;
    
    &:hover {
      opacity: 1;
    }
  }
`;
